import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { app } from '..';
import Button from './Button';

// Styles
import './Modal.css';

interface Props {
  bodyCls?: string;
  children: any;
  closeHandler?: any;
  cls?: string;
  side: string;
  title?: string;
  unmountCb?: Function;
}

export const renderInModal = (child: React.ReactElement, side?: string, title?: string) => {
  const position = side || "center";
  render(<Modal side={position} title={title}>
    {child}
  </Modal>, document.getElementById('modalRoot'));
};

export const closeModal = () => {
  //@ts-ignore
  render(null, document.getElementById('modalRoot'));
};

export const Modal = (props: Props) => {
  const animationCls = `modal-show-${props.side}`;
  const cls = `modal modal-${props.side} ${animationCls} ${props.cls || ''}`;
  const bodyCls = `body ${props.bodyCls || ''}`;
  const closeHandler = () => closeModal();

  return <Provider store={app.getReduxStore()}><div className="modal-wrap">
    <div className="modal-overlay" onClick={closeHandler}></div>
    <div className={cls}>
      <div className="header">
        <div className="title">{props.title}</div>
        <Button onClick={closeHandler} className="close-tool" faIconCls="fa-times" />
      </div>
      <div className={bodyCls}>
        {props.children}
      </div>
    </div>
  </div></Provider>

};
